/**
 * The one grader of a rationale's expectation (ADR-0053): "You expected X up; it moved …" is read the same on the round's results and in the finale, so both take the verdict from here
 * (the API stamps it on the finale's `expectedVsActual` row, keyed by the rationale's id). A move that prints as zero (inside half one printed step of the measure's level) reads as no move: 0.0 pts is never "it did".
 */
import { KPI_DEFS, type KpiId } from "@bsim/domain";
import { changeNoiseBand, changeScaleOf, printedChangeBand } from "@gxs/metric-defs";

export type RationaleVerdict = "As expected" | "Opposite" | "Too small to tell";

/** Half the smallest step a change of the measure shows in. */
export const noiseBandOf = (kpi: KpiId): number => changeNoiseBand(KPI_DEFS[kpi].unit, changeScaleOf(kpi));

/** Half one printed step of the measure's level: a move under it prints as zero. */
export const printedBandOf = (kpi: KpiId): number => printedChangeBand(KPI_DEFS[kpi].unit, kpi);

export function rationaleVerdict(direction: "up" | "down" | "flat", kpi: KpiId, delta: number | undefined): RationaleVerdict {
  if (delta === undefined) return "Too small to tell";
  if (Math.abs(delta) < printedBandOf(kpi)) return direction === "flat" ? "As expected" : "Too small to tell";
  if (direction === "flat") return "Opposite";
  return (delta > 0) === (direction === "up") ? "As expected" : "Opposite";
}
